import React from "react";

import { DataTableBody, DataTableHead, DataTableRow } from "../Component";
import OpendaysPageTableItems from "./OpendaysPageTableItems";

const OpendaysPageTableBody = ({ users, setUsers }) => {
  const onSelectChange = (e, id) => {
    let newData = users;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].check = e.currentTarget.checked;
    setUsers([...newData]);
  };

  const selectorCheck = (e) => {
    let newData;
    newData = users.map((item) => {
      item.check = e.currentTarget.checked;
      return item;
    });
    setUsers([...newData]);
  };

  return (
    <DataTableBody compact>
      <DataTableHead>
        <DataTableRow className="nk-tb-col-check" noText>
          <div className="custom-control custom-control-sm custom-checkbox notext">
            <input
              type="checkbox"
              className="custom-control-input form-control"
              id="pid-all"
              onChange={(e) => selectorCheck(e)}
            />
            <label className="custom-control-label" htmlFor="pid-all"></label>
          </div>
        </DataTableRow>
        <DataTableRow text="School" />
        <DataTableRow text="Date" />
        <DataTableRow text="Attendees" />
        <DataTableRow text="Program of Interest" />
        <DataTableRow text="Hear" />
        <DataTableRow className="nk-tb-col-tools" noText />
      </DataTableHead>
      {users?.map((item) => {
        return (
          <OpendaysPageTableItems
            key={item?.id}
            item={item}
            onSelectChange={onSelectChange}
          />
        );
      })}
    </DataTableBody>
  );
};

export default OpendaysPageTableBody;
